module.exports = __webpack_public_path__ + "assets/img/ripple.3958918b.jpg";